(function() {

  let _cartCache = null;
  let _cartCacheTime = 0;
  let _initialized = false;

  async function getCart() {
    const now = Date.now();
    if (_cartCache && (now - _cartCacheTime) < 5000) return _cartCache;
    _cartCache = await fetch('/cart.js').then(r => r.json());
    _cartCacheTime = Date.now();
    return _cartCache;
  }

  async function loadUpsellProducts() {
    if (_initialized) return;
    const container = document.getElementById('ms-upsell-items');
    if (!container) return;

    try {
      const cart = await getCart();
      if (!cart.items.length) return;

      const firstProductId = cart.items[0].product_id;
      const cartProductIds = cart.items.map(i => i.product_id);
      const cartSize = cart.items[0].variant_title?.split(' / ')[0] || '';

      const data = await fetch(
        '/recommendations/products.json?product_id=' + firstProductId + '&limit=8&intent=related'
      ).then(r => r.json());

      const mainRecs = (data.products || [])
        .filter(p => !cartProductIds.includes(p.id))
        .slice(0, 2);

      let accessoryProduct = null;
      try {
        const accRes = await fetch('/collections/akcesoria/products.json?limit=20');
        const accData = await accRes.json();
        const available = (accData.products || []).filter(p => !cartProductIds.includes(p.id));
        if (available.length > 0) {
          const raw = available[Math.floor(Math.random() * available.length)];
          accessoryProduct = {
            id: raw.id,
            title: raw.title,
            handle: raw.handle,
            variants: raw.variants.map(v => ({
              ...v,
              price: Math.round(parseFloat(v.price) * 100),
              compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : null,
            })),
            featured_image: raw.images?.[0]?.src || null,
            options: raw.options || [],
          };
        }
      } catch(e) {}

      const combined = accessoryProduct ? [...mainRecs, accessoryProduct] : mainRecs.slice(0, 3);
      const seen = new Set();
      const finalProducts = combined.filter(p => {
        if (seen.has(p.id)) return false;
        seen.add(p.id);
        return true;
      });

      if (!finalProducts.length) {
        const section = container.closest('.ms-upsell');
        if (section) section.style.display = 'none';
        return;
      }

      container.innerHTML = finalProducts.map(p => {
        const matched = p.variants.find(v => v.option1 === cartSize && v.available)
          || p.variants.find(v => v.available)
          || p.variants[0];
        const price = (parseInt(matched.price) / 100).toFixed(2).replace('.', ',');
        const compare = matched.compare_at_price && parseInt(matched.compare_at_price) > parseInt(matched.price)
          ? (parseInt(matched.compare_at_price) / 100).toFixed(2).replace('.', ',')
          : null;
        const _fi = (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image?.src) || '';
        const img = _fi ? (_fi.startsWith('http') ? _fi : 'https:' + _fi) : (p.images?.[0]?.src ? 'https:' + p.images[0].src : '');
        const priceHTML = compare
          ? '<span class="ms-upsell__price-regular">' + price + ' zł</span> <span class="ms-upsell__price-compare">' + compare + ' zł</span>'
          : '<span class="ms-upsell__price-regular">' + price + ' zł</span>';
        return '<div class="ms-upsell__item" data-product-id="' + p.id + '" data-product-handle="' + p.handle + '">' +
          '<img src="' + img + '" alt="' + p.title + '" loading="lazy" width="52" height="52">' +
          '<div class="ms-upsell__item-info">' +
            '<div class="ms-upsell__item-name">' + p.title + '</div>' +
            '<div class="ms-upsell__item-price">' + priceHTML + '</div>' +
          '</div>' +
          '<button class="ms-upsell__item-btn" data-product-handle="' + p.handle + '">Dodaj +</button>' +
          '<div class="ms-upsell__sizes"></div>' +
        '</div>';
      }).join('');

      _initialized = true;

    } catch(e) {
      const section = container.closest('.ms-upsell');
      if (section) section.style.display = 'none';
    }
  }

  async function addVariantToCart(variantId) {
    // 1. Dodaj produkt do koszyka
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    // 2. Pobierz odświeżoną sekcję koszyka przez Shopify sections API
    const sectionId = document.querySelector('cart-items-component')?.dataset?.sectionId;
    if (!sectionId) return;

    const sectionsData = await fetch('/?sections=' + sectionId)
      .then(r => r.json())
      .catch(() => null);

    if (!sectionsData || !sectionsData[sectionId]) return;

    // 3. Wstaw nowy HTML sekcji do tymczasowego diva
    const tmp = document.createElement('div');
    tmp.innerHTML = sectionsData[sectionId];

    // 4. Zamień tylko listę produktów - zostaw upsell i pasek
    const newTable = tmp.querySelector('.cart-items__table');
    const oldTable = document.querySelector('.cart-items__table');
    if (newTable && oldTable) {
      oldTable.replaceWith(newTable);
    }

    // 5. Odświeź licznik koszyka w headerze
    const newBubble = tmp.querySelector('.cart-bubble');
    const oldBubble = document.querySelector('.cart-bubble');
    if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);

    // 6. Odśwież pasek darmowej dostawy przez nowy liquid render
    const newShipping = tmp.querySelector('.ms-shipping-bar');
    const oldShipping = document.querySelector('.ms-shipping-bar');
    if (newShipping && oldShipping) oldShipping.replaceWith(newShipping);

    // 7. Odśwież cenę na przycisku checkout
    const oldPrice = document.getElementById('ms-checkout-price');
    if (oldPrice) {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        if (cart.total_price !== undefined) {
          oldPrice.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' zł';
        }
      });
    }
  }

  function checkUpsellEmpty() {
    const container = document.getElementById('ms-upsell-items');
    if (container && !container.querySelector('.ms-upsell__item')) {
      const section = container.closest('.ms-upsell');
      if (section) section.style.display = 'none';
    }
  }

  async function init() {
    _cartCache = null;
    const cart = await getCart();
    if (!cart.items || cart.items.length === 0) return;
    const priceEl = document.getElementById('ms-checkout-price');
    if (priceEl && cart.total_price) {
      priceEl.textContent = ' ' + (cart.total_price / 100).toFixed(2).replace('.', ',') + ' zł';
    }
    loadUpsellProducts();
  }

  function setupDrawerWatcher() {
    const dialog = document.querySelector('cart-drawer-component dialog, .cart-drawer__dialog');
    if (!dialog) {
      setTimeout(setupDrawerWatcher, 500);
      return;
    }

    // Obserwuj atrybut "open" na dialog - pojawia się gdy drawer jest otwarty
    const obs = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'open') {
          if (dialog.hasAttribute('open')) {
            // Always reset so loadUpsellProducts re-fetches with current cart state
            _initialized = false;
            _cartCache = null;
            setTimeout(init, 200);
          }
        }
      });
    });

    obs.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState !== 'loading') {
    setupDrawerWatcher();
  } else {
    document.addEventListener('DOMContentLoaded', setupDrawerWatcher);
  }

})();

// Zachowaj upsell podczas operacji na koszyku
(function() {
  window._upsellGuardLocked = false;
  let _upsellSnapshot = '';
  let _cartHandlesCache = new Set();

  // Cache cart handles — refresh co 2s + na cart events
  async function refreshCartHandles() {
    try {
      const cart = await fetch('/cart.js', {cache: 'no-store'}).then(r => r.json());
      _cartHandlesCache = new Set(cart.items.map(i => i.handle));
    } catch(e) {}
  }
  refreshCartHandles();
  setInterval(refreshCartHandles, 2000);
  document.addEventListener('cart:update', refreshCartHandles);
  document.addEventListener('cart:refresh', refreshCartHandles);
  document.addEventListener('cart:added', refreshCartHandles);

  // Filtr: usuń is-removing items i te już w koszyku
  function cleanUpsellHTML(html) {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    Array.from(tmp.children).forEach(item => {
      const handle = item.dataset.productHandle;
      const isOrphan = item.classList.contains('is-removing');
      if (isOrphan || (handle && _cartHandlesCache.has(handle))) {
        item.remove();
      }
    });
    return tmp.innerHTML;
  }

  // Hide/show wrapper based on items
  function syncWrapperVisibility() {
    const items = document.getElementById('ms-upsell-items');
    const wrapper = document.getElementById('ms-upsell');
    if (!items || !wrapper) return;
    wrapper.style.display = items.children.length === 0 ? 'none' : '';
  }

  // Snapshot z filtrowaniem
  setInterval(function() {
    const items = document.getElementById('ms-upsell-items');
    if (!items) return;

    // Posprzątaj DOM z orphans + items already in cart (nie tylko snapshot)
    Array.from(items.children).forEach(item => {
      const handle = item.dataset.productHandle;
      const isOrphan = item.classList.contains('is-removing');
      if (isOrphan || (handle && _cartHandlesCache.has(handle))) {
        item.remove();
      }
    });

    // Zapisz snapshot tylko gdy są realne, nieprzeterminowane items
    if (items.querySelector('.ms-upsell__item')) {
      _upsellSnapshot = items.innerHTML;
      window._upsellSnapshot = _upsellSnapshot;
    } else {
      // Brak items → wyczyść snapshot, schowaj wrapper
      _upsellSnapshot = '';
      window._upsellSnapshot = '';
    }
    syncWrapperVisibility();
  }, 500);

  // Watcher restoruje TYLKO przefiltrowany snapshot
  function watchUpsell() {
    const upsell = document.getElementById('ms-upsell');
    if (!upsell) { setTimeout(watchUpsell, 500); return; }
    new MutationObserver(function() {
      const items = document.getElementById('ms-upsell-items');
      if (items && !items.querySelector('.ms-upsell__item') && _upsellSnapshot && !window._upsellGuardLocked) {
        setTimeout(function() {
          const el = document.getElementById('ms-upsell-items');
          if (el && !el.querySelector('.ms-upsell__item') && _upsellSnapshot && !window._upsellGuardLocked) {
            const cleaned = cleanUpsellHTML(_upsellSnapshot);
            if (cleaned.trim()) {
              el.innerHTML = cleaned;
              const section = el.closest('.ms-upsell');
              if (section) section.style.display = '';
            } else {
              // Snapshot pusty po filtrowaniu → wyczyść i schowaj
              _upsellSnapshot = '';
              window._upsellSnapshot = '';
              syncWrapperVisibility();
            }
          }
        }, 50);
      }
    }).observe(upsell, { childList: true, subtree: true });
  }
  watchUpsell();
})();
